export default "__VITE_ASSET__CGrPaOkt__"